// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const assetsClient = createTypedClient();
export const createAssetsClient = (config) => createTypedClient(config);
